export default "__VITE_ASSET__41245300__"